// @flow
import React, {useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import {useForm} from 'react-hook-form';
import {usePrevious} from '../../../../utils/react';
import CustomTextField from '../../../../elements/CustomTextField/CustomTextField';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import {colors} from '../../../../assets/styles/colors';

import {useChangePasswordAccount} from '../utils';

type Props = {|
  isSaving?: boolean,
|};

const useStyles = makeStyles(theme => ({
  saveButton: {
    margin: 'auto',
    color: 'white',
    backgroundColor: colors.purple3,
  },
  center: {
    display: 'flex',
    alignItems: 'center',
  },
}));

export default function AccountSecurity(props: Props) {
  const {isSaving} = props;

  const classes = useStyles();

  const changeAccountPassword = useChangePasswordAccount();

  const {handleSubmit, register, errors, watch, setValue} = useForm();

  const prevIsSaving = usePrevious(isSaving);

  const onSubmit = values => {
    changeAccountPassword(values.password);
  };

  useEffect(() => {
    if (prevIsSaving && !isSaving) {
      setValue('password', '');
      setValue('repeatPassword', '');
    }
  });

  return (
    <div>
      <form noValidate onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2} justify="center">
          <Grid item xs={12} sm={12} md={12}>
            <CustomTextField
              label="Contraseña"
              name="password"
              autoComplete="current-password"
              error={!!errors.password}
              helperText={errors.password ? errors.password.message : ''}
              inputRef={register({
                required: 'Campo obligatorio',
              })}
              type="password"
              disabled={isSaving}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <CustomTextField
              label="Repetir contraseña"
              name="repeatPassword"
              autoComplete="new-password"
              error={!!errors.repeatPassword}
              helperText={
                errors.repeatPassword ? errors.repeatPassword.message : ''
              }
              inputRef={register({
                required: 'Campo obligatorio',
                validate: value =>
                  value === watch('password') || 'Las contraseñas no coinciden',
              })}
              type="password"
              disabled={isSaving}
            />
          </Grid>
          <Grid item xs={12} sm={10} md={10} className={classes.center}>
            <CustomButton
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              size="large"
              className={classes.saveButton}
              disabled={isSaving}
            >
              Guardar cambios
            </CustomButton>
          </Grid>
        </Grid>
      </form>
    </div>
  );
}

AccountSecurity.propTypes = {
  saveAccountSettings: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
};
